import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AtSignIcon, LockIcon, LoaderIcon, AlertCircleIcon } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      navigate('/', {
        replace: true
      });
    } catch (err) {
      setError('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 px-4" data-id="element-584">
      <div className="w-full max-w-md space-y-8" data-id="element-585">
        <div className="text-center" data-id="element-586">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3YBd7gd7d4PCmnKxZ3UB6K/nexus_datatodeals-logo.png" alt="NEXUS" className="h-24 mx-auto mb-4" data-id="element-587" />
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200" data-id="element-588">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-589">
            {error && <div className="flex items-center gap-2 text-sm text-red-600 bg-red-50 p-3 rounded-md" data-id="element-590">
                <AlertCircleIcon size={16} data-id="element-591" />
                <p data-id="element-592">{error}</p>
              </div>}
            <div className="space-y-4" data-id="element-593">
              <div data-id="element-594">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-595">
                  E-Mail
                </label>
                <div className="mt-1 relative" data-id="element-596">
                  <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm pl-10 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="name@unternehmen.de" required data-id="element-597" />
                  <AtSignIcon size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-598" />
                </div>
              </div>
              <div data-id="element-599">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-600">
                  Passwort
                </label>
                <div className="mt-1 relative" data-id="element-601">
                  <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm pl-10 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="••••••••" required data-id="element-602" />
                  <LockIcon size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-603" />
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-604">
              <div className="flex items-center" data-id="element-605">
                <input id="remember-me" type="checkbox" className="h-4 w-4 text-blue-500 border-gray-300 rounded focus:ring-blue-500" data-id="element-606" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-607">
                  Angemeldet bleiben
                </label>
              </div>
              <button type="button" className="text-sm font-medium text-[#17B978] hover:text-[#148F5F]" data-id="element-608">
                Passwort vergessen?
              </button>
            </div>
            <button type="submit" disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#17B978] hover:bg-[#148F5F] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#17B978] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-609">
              {isLoading ? <LoaderIcon size={16} className="animate-spin mr-2" data-id="element-610" /> : null}
              Anmelden
            </button>
          </form>
          <div className="mt-6" data-id="element-611">
            <div className="relative" data-id="element-612">
              <div className="absolute inset-0 flex items-center" data-id="element-613">
                <div className="w-full border-t border-gray-300" data-id="element-614" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-615">
                <span className="px-2 bg-white text-gray-500" data-id="element-616">
                  Oder fortfahren mit
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-3 gap-3" data-id="element-617">
              <button disabled className="w-full inline-flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-gray-50 text-sm font-medium text-gray-400 cursor-not-allowed" title="Social Login ist derzeit nicht verfügbar" data-id="element-618">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/512px-Microsoft_logo.svg.png" alt="Microsoft" className="h-5 w-5 opacity-50" data-id="element-619" />
              </button>
              <button disabled className="w-full inline-flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-gray-50 text-sm font-medium text-gray-400 cursor-not-allowed" title="Social Login ist derzeit nicht verfügbar" data-id="element-620">
                <img src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" alt="Google" className="h-5 w-5 opacity-50" data-id="element-621" />
              </button>
              <button disabled className="w-full inline-flex justify-center items-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-gray-50 text-sm font-medium text-gray-400 cursor-not-allowed" title="Social Login ist derzeit nicht verfügbar" data-id="element-622">
                <img src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png" alt="LinkedIn" className="h-5 w-5 opacity-50" data-id="element-623" />
              </button>
            </div>
          </div>
        </div>
        <p className="text-center text-sm text-gray-600" data-id="element-624">
          <span className="text-xs text-gray-400 mr-2" data-id="element-625">v1.56</span>
          Noch kein Konto?{' '}
          <button className="font-medium text-[#17B978] hover:text-[#148F5F]" data-id="element-626">
            Jetzt registrieren
          </button>
        </p>
      </div>
    </div>;
}